<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'

const navOpen = ref(false)
const route = useRoute()
</script>

<template>
  <nav class="navbar navbar-expand-lg header" role="navigation" aria-label="Navigation principale">
    <div class="container">

      <!-- LOGO -->
      <a
        href="https://www.reseau-colibri.fr"
        class="navbar-brand"
        aria-label="Retour au site principal Réseau Colibri"
      >
        <img
          src="@/assets/logo.png"
          alt="Logo du réseau de transport Réseau Colibri"
          width="225"
        />
      </a>

      <!-- BOUTON MENU MOBILE -->
      <button
        class="navbar-toggler btn_menu"
        type="button"
        :aria-expanded="navOpen.toString()"
        aria-controls="navbar-menu"
        :aria-label="navOpen ? 'Fermer le menu de navigation' : 'Ouvrir le menu de navigation'"
        @click="navOpen = !navOpen"
      >
        <span class="icon_menu" aria-hidden="true">
          <i class="fas fa-bars fa-2x"></i>
        </span>
      </button>

      <!-- MENU -->
      <div
        id="navbar-menu"
        class="navbar-collapse liste_btn"
        :class="{ collapse: !navOpen, show: navOpen }"
      >
        <div class="navbar-nav ms-auto">

          <!-- ACCUEIL -->
          <router-link
            :to="{ name: 'home' }"
            class="btn_header btn my-2 my-lg-0 me-lg-2"
            :aria-current="route.name === 'home' ? 'page' : undefined"
          >
            Accueil billetterie
          </router-link>

          <!-- AIDE -->
          <router-link
            :to="{ name: 'aide' }"
            class="btn_header btn my-2 my-lg-0"
            :aria-current="route.name === 'aide' ? 'page' : undefined"
          >
            Mode d'emploi
          </router-link>

        </div>
      </div>

    </div>
  </nav>
</template>

<style scoped lang="scss">
@import "@/assets/main";

.header {
  margin-bottom: 3rem;
  background-color: $firstcolor;

  img {
    width: 225px;
  }

  .btn_header {
    color: $firstcolor;
    text-transform: uppercase;
    background-color: white;
    border-radius: 50px;
  }

  .btn_header:hover,
  .btn_header:focus-visible {
    color: white;
    background-color: $firstcolor;
    border: 1px solid white;
    outline: 3px solid white;
    outline-offset: 2px;
  }

  .btn_header[aria-current="page"] {
    color: white;
    background-color: darken($firstcolor, 10%);
    border: 1px solid white;
  }

  .btn_menu {
    border-color: transparent;
    color: white;

    &:focus-visible {
      outline: 3px solid white;
      outline-offset: 2px;
    }

    @media (min-width: 992px) {
      display: none;
    }
  }
}
</style>
